// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
// import './assets/css/bootstrap.min.css'
// import './assets/js/bootstrap.min'

import '../static/three/jquery.form.js'

import '../static/three/bootstrap/css/bootstrap.min.css'
import '../static/three/bootstrap/css/bootstrap-theme.min.css'
import '../static/three/bootstrap/js/bootstrap.min'
import '../static/three/bootstrap/js/bootstrap-select.min.js'
import '../static/three/bootstrap/css/bootstrap-select.min.css'
import '../static/three/colorpick/css/bootstrap-colorpicker.min.css'
import '../static/three/colorpick/js/bootstrap-colorpicker.min'
import '../static/three/bootstrap-slider.min.css'
import '../static/three/bootstrap-slider.min'

import  VueResource  from 'vue-resource'
import axios from 'axios'

Vue.use(VueResource)
Vue.config.productionTip = false
Vue.prototype.$axios = axios

global.eventBus = new Vue({})

Vue.filter('fixedFloat', function (value, num) {
  return value.toFixed(num)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App, $, VueResource }
})



// WEBPACK FOOTER //
// ./src/main.js